// Chakra imports
import {
    Box,
    Button,
    Flex,
    HStack,
    Input,
    InputGroup,
    InputLeftElement,
    Table,
    Tbody,
    Text,
    Th,
    Thead,
    Tr,
    useColorModeValue,
    useDisclosure,
    useToast,
} from "@chakra-ui/react";
// Custom components
import Card from "../../../components/Card/Card.js";
import CardBody from "../../../components/Card/CardBody.js";
import CardHeader from "../../../components/Card/CardHeader.js";
import React, {useEffect, useState} from "react";
import BellSetupTableRow from "./BellTableRow";
import AddBellModal from "./AddBellModal";
import DeleteBellSetupModal from "./DeleteBellSetupModal";
import {saveBellMusic, searchBellMusic} from "./Services";
import {FaSearch} from "react-icons/fa";

const Bell = ({title, captions, data}) => {

    const toast = useToast();

    const textColor = useColorModeValue("gray.700", "white");
    const {isOpen, onOpen, onClose} = useDisclosure(); // Modal state management
    const [bellSetupList, setBellSetupList] = useState("");
    const [bellSetupId, setBellSetupId] = useState(null);

    const [isApproveModalOpen, setIsApproveModalOpen] = useState(false);
    const [isBlockBellSetupModal, setIsBlockBellSetupModal] = useState(false);


    const [selectedSound, setSelectedSound] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");

    useEffect(() => {
        fetchBellSetupList();
    }, []);

    const fetchBellSetupList = async () => {

        try {
            let request = {
                schoolId: null,
                name: ""
            }
            const response = await searchBellMusic(request, 1, 10);
            console.log("rrr", response)
            if (response.status === 200) {
                setBellSetupList(response.data);
            }
        } catch (e) {
            console.error("Error while fetching bellSetup list e:", e);
        }
    }

    const handleBellSubmit = async (bellSetupDetails) => {

        let request = {
            bellList: [{
                name: bellSetupDetails.name,
                url: bellSetupDetails.url,
                type: bellSetupDetails.type,
                enabled: bellSetupDetails.enabled
            }]
        };

        try {
            const response = await saveBellMusic(request);
            console.log(response)
            if (response.status === 201) {
                toast({
                    title: "Success!",
                    description: "Bell details saved successfully.",
                    status: "success",
                    duration: 5000,
                    isClosable: true,
                });
                onClose();
                await fetchBellSetupList();
            }

        } catch (e) {
            console.error("Error while submiting bellSetup details e:", e);
        }
    }

    const handeBellSetupUpload = () => {
    }


    const handleApproveModalOpen = () => {
        setIsApproveModalOpen(true);
    }
    const handleApproveModalClose = () => {
        setIsApproveModalOpen(false);
    }

    const handleBlockBellSetupModal = (bellSetup, flag) => {
        if (flag === true) {
            setBellSetupId(bellSetup.id)
        }
        setIsBlockBellSetupModal(flag);
    }

    const handleBellSetupDetailModal = async (bellSetup, flag) => {

        if (flag === true) {
            try {
                let request = {
                    bellSetupId: Number(bellSetup.id),
                }

                const response = await fetchBellSetupDetail(request);
                if (response.status === 200) {
                    setBellSetupDetail(response.data)
                }

            } catch (e) {
                console.error("Error while trying to handle bellSetup approval :{}", e);
            }
        }
        setDetailModal(flag);
    }


    return (
        <Card overflowX={{sm: "scroll", xl: "hidden"}}>
            <CardHeader p="16px 0 24px 0">
                <Flex justify="space-between" align="center" wrap="wrap" gap="12px">
                    {/* Title on the left */}
                    <Text fontSize="lg" color={textColor} fontWeight="semibold" flex="1" isTruncated>
                        {title}
                    </Text>

                    {/* Buttons on the right */}
                    <HStack spacing="3" wrap="wrap">
                        <Button colorScheme="blue" size="sm" onClick={onOpen}>
                            Add BellSetup
                        </Button>
                    </HStack>
                </Flex>

                <Box mb={8}>
                    <InputGroup borderRadius="md" boxShadow="sm">
                        <InputLeftElement pointerEvents="none"
                                          children={<FaSearch color="gray.500"/>}/>
                        <Input
                            type="text"
                            placeholder="Search for a sound..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            borderRadius="md"
                            boxShadow="sm"
                        />
                    </InputGroup>
                </Box>
            </CardHeader>

            <CardBody>
                <>
                    <Table variant='simple' color={textColor}>
                        <Thead>
                            <Tr my='.8rem' pl='0px' color='gray.400'>
                                {captions && captions.map((caption, idx) => {
                                    return (
                                        <Th color='gray.400' key={idx} ps={idx === 0 ? "0px" : null}>
                                            {caption}
                                        </Th>
                                    );
                                })}
                            </Tr>
                        </Thead>
                        <Tbody>
                            <>
                                {isOpen ?
                                    <AddBellModal
                                        isOpen={isOpen}
                                        onClose={onClose}
                                        handeBellSetupUpload={handeBellSetupUpload}
                                        handleBellSubmit={handleBellSubmit}
                                    /> : ""
                                }
                                {isBlockBellSetupModal ?
                                    <DeleteBellSetupModal
                                        isOpen={isBlockBellSetupModal}
                                        handleBlockBellSetupModal={handleBlockBellSetupModal}
                                        handleBellSetupBlock={handleBellSetupBlock}
                                        bellSetupId={bellSetupId}
                                    /> : ""
                                }
                                {bellSetupList && bellSetupList.map((bellSetup, index) => {
                                    return (
                                        <BellSetupTableRow
                                            sn={index + 1}
                                            bellSetup={bellSetup}
                                            isApproveModalOpen={isApproveModalOpen}
                                            handleApproveModalClose={handleApproveModalClose}
                                            handleApproveModalOpen={handleApproveModalOpen}
                                            handleBlockBellSetupModal={handleBlockBellSetupModal}
                                            handleBellSetupDetailModal={handleBellSetupDetailModal}
                                        />
                                    );
                                })}
                            </>
                        </Tbody>
                    </Table>
                </>
            </CardBody>
        </Card>
    );
};

export default Bell;
